import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";

export const AnularBtn = ({ url, done, testid }) => {
  const go = async (e) => {
    e.stopPropagation();
    const motivo = window.prompt("Motivo de anulación (obligatorio)");
    if (motivo === null) return;
    if (motivo.trim().length < 5) { toast.error("Escribe un motivo de al menos 5 caracteres"); return; }
    try { await http.post(url, { motivo }); toast.success("Registro anulado"); done(); } catch (er) { toast.error(errMsg(er)); }
  };
  return <button onClick={go} data-testid={testid} className="ml-2 rounded-md border border-rose-200 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-rose-700 hover:bg-rose-50">Anular</button>;
};

export const AnuladosToggle = ({ value, set, testid }) => (
  <label className="flex items-center gap-1.5 text-xs text-[#5C5850]"><input type="checkbox" checked={value} onChange={(e) => set(e.target.checked)} data-testid={testid} /> Mostrar anulados</label>
);

export const AnuladoTag = ({ d }) => (d.anulado ? <span className="ml-2 rounded bg-rose-100 px-1.5 py-0.5 text-[10px] font-semibold text-rose-700" title={`${d.anulado_por}: ${d.anulado_motivo}`}>ANULADO · {d.anulado_motivo}</span> : null);
